import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    isBlog: {},

    header: {
      display: 'flex',
      alignItems: 'center',
    },
    boxGroupTitle: {
      flex: 1,
    },
    buttonSettings: {
      margin: theme.spacing(-1, 0), // we want reasonable clickable area for the button, but don't want to influence panel vertical free space
      color: COLORS.gray.gray30,
    },
    wrapper: {
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(1),
      padding: theme.spacing(3, 2),
      backgroundColor: COLORS.neutral.white,
      borderRadius: theme.shape.borderRadiusSemiLarge,

      '$isBlog &': {
        border: theme.shape.borderGray70,
      },
    },
    brandTermsItem: {},
  }),
  { name: 'BrandTerms' }
);
